// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Landing Page Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translate3d(-40px, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(40px, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

.animate-fade-up {
  animation: fadeInUp 0.8s ease forwards;
}

.animate-fade-left {
  animation: fadeInLeft 0.8s ease forwards;
}

.animate-fade-right {
  animation: fadeInRight 0.8s ease forwards;
}

.animate-scale-in {
  animation: scaleIn 0.8s ease forwards;
}

.animate-bounce {
  animation: bounce 2s infinite;
}

.animation-delay-100 {
  animation-delay: 100ms;
}

.animation-delay-200 {
  animation-delay: 200ms;
}

.animation-delay-300 {
  animation-delay: 300ms;
}

.animation-delay-400 {
  animation-delay: 400ms;
}

.animation-delay-500 {
  animation-delay: 500ms;
}

/* Hover animations for cards */
.hover-lift {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-lift:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
}

.hover-glow {
  transition: box-shadow 0.3s ease;
}

.hover-glow:hover {
  box-shadow: 0 0 20px rgba(104, 64, 217, 0.4) !important;
}

/* Animated elements */
.animated-count {
  font-weight: bold;
  font-size: 3rem;
  background: linear-gradient(135deg, #8a4baf 0%, #6840d9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Animated backgrounds */
.animated-bg {
  position: relative;
  overflow: hidden;
}

.animated-bg::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 200%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: shine 1.5s infinite;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Scroll reveal animations */
.reveal {
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.reveal.active {
  opacity: 1;
  transform: translateY(0);
}

.reveal-left {
  transform: translateX(-50px);
}

.reveal-right {
  transform: translateX(50px);
}

.reveal-up {
  transform: translateY(50px);
}

.reveal-down {
  transform: translateY(-50px);
}

.reveal-scale {
  transform: scale(0.9);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing/landing-animations.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uDAAuD;AACzD;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,eAAe;EACf,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* Landing Page Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 40px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translate3d(-40px, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translate3d(40px, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-20px);\n  }\n  60% {\n    transform: translateY(-10px);\n  }\n}\n\n.animate-fade-up {\n  animation: fadeInUp 0.8s ease forwards;\n}\n\n.animate-fade-left {\n  animation: fadeInLeft 0.8s ease forwards;\n}\n\n.animate-fade-right {\n  animation: fadeInRight 0.8s ease forwards;\n}\n\n.animate-scale-in {\n  animation: scaleIn 0.8s ease forwards;\n}\n\n.animate-bounce {\n  animation: bounce 2s infinite;\n}\n\n.animation-delay-100 {\n  animation-delay: 100ms;\n}\n\n.animation-delay-200 {\n  animation-delay: 200ms;\n}\n\n.animation-delay-300 {\n  animation-delay: 300ms;\n}\n\n.animation-delay-400 {\n  animation-delay: 400ms;\n}\n\n.animation-delay-500 {\n  animation-delay: 500ms;\n}\n\n/* Hover animations for cards */\n.hover-lift {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.hover-lift:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;\n}\n\n.hover-glow {\n  transition: box-shadow 0.3s ease;\n}\n\n.hover-glow:hover {\n  box-shadow: 0 0 20px rgba(104, 64, 217, 0.4) !important;\n}\n\n/* Animated elements */\n.animated-count {\n  font-weight: bold;\n  font-size: 3rem;\n  background: linear-gradient(135deg, #8a4baf 0%, #6840d9 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* Animated backgrounds */\n.animated-bg {\n  position: relative;\n  overflow: hidden;\n}\n\n.animated-bg::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 200%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  animation: shine 1.5s infinite;\n}\n\n@keyframes shine {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Scroll reveal animations */\n.reveal {\n  opacity: 0;\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.reveal.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.reveal-left {\n  transform: translateX(-50px);\n}\n\n.reveal-right {\n  transform: translateX(50px);\n}\n\n.reveal-up {\n  transform: translateY(50px);\n}\n\n.reveal-down {\n  transform: translateY(-50px);\n}\n\n.reveal-scale {\n  transform: scale(0.9);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
